$(function () {
    $(".site-navigation").detach().appendTo("#full-width");
})